export const BrandLogo = ({
    variant = 'wordmark',
    className = '',
    imgClassName = '',
    showSubtitle = false,
    subtitle = 'Accounting Information System',
    subtitleClassName = ''
}) => {
    const isMark = variant === 'mark';
    const src = isMark ? '/macesuite-logo-mark.png' : '/macesuite-logo.png';

    return (
        <div className={className}>
            <img
                src={src}
                alt="MaceSuite"
                className={imgClassName}
                draggable="false"
            />
            {showSubtitle && (
                <p className={subtitleClassName}>
                    {subtitle}
                </p>
            )}
        </div>
    );
};
